import * as React from 'react';
import { useDataLoader, usePerformAction } from 'react-remote-data-hooks';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import api from '../../../../api';
import CreateForm from './CreateForm';
import { useLeadIntent } from '../../../../core/hooks';
import { toastr } from 'react-redux-toastr';
import { Checklist } from '../../../../core';

const CheckListManagement: React.FunctionComponent = () => {
  const [editModal, setEditModal] = useStateWithCallbackLazy<{
    data?: Checklist;
    isOpen?: boolean;
  }>({});
  const { data, reload } = useDataLoader<Checklist[]>(() =>
    api.checklist.loadAllChecklist()
  );
  const {
    performAction: updateCheckList,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (formData: Checklist, id?: string) =>
      api.checklist.updateChecklist(
        {
          ...formData,
        },
        id
      ),
    () => {
      reload();
      closeModal();
    },
    (error) => {
      toastr.error('Error', (error as any)?.response?.data?.message);
    }
  );
  const {
    performAction: createCheckList,
    error: createError,
    isPerforming: creating,
  } = usePerformAction(
    (formData: Checklist) =>
      api.checklist.createChecklist({
        ...formData,
      }),
    () => {
      reload();
      closeModal();
    },
    (error) => {
      toastr.error('Error', (error as any)?.response?.data?.message);
    }
  );
  const {
    performAction: deleteCheckList,
    error: deleteError,
    isPerforming: deleting,
  } = usePerformAction(
    (id?: string) => api.checklist.deleteChecklist(id),
    () => {
      reload();
      closeModal();
    },
    (error) => {
      toastr.error('Error', (error as any)?.response?.data?.message);
    }
  );
  const update = (updateData: Checklist) => {
    const id = editModal?.data?._id;
    if (!id) {
      createCheckList(updateData);
    } else {
      updateCheckList(updateData, id);
    }
  };
  const closeModal = () => {
    setEditModal({}, () => {
      // console.log("model closed")
    });
  };
  const showEditModal = (modeData: Checklist) => {
    setEditModal({}, () => {
      setEditModal({ data: modeData, isOpen: true }, () => {
        // console.log("model closed")
      });
    });
  };
  const showCreateModal = () => {
    setEditModal({}, () => {
      setEditModal({ isOpen: true }, () => {
        // console.log("model closed")
      });
    });
  };
  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Check List Management</h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => showCreateModal()}
            >
              <i className="icon-plus mr-1 font-xs"></i> Add
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Item</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => {
                return (
                  <tr
                    onClick={() => showEditModal(item)}
                    className="cursor-pointer"
                  >
                    <td>{item.name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModal.isOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <CreateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating || creating}
              data={editModal.data}
              onCancel={() => closeModal()}
              onDelete={(id?: string) => deleteCheckList(id)}
            ></CreateForm>
          </>
        )}
      </div>
    </>
  );
};
export default CheckListManagement;
